import {withStyles} from '@/hocs/withStyles';
import {Noop} from '@/hocs/noop';
import styles from './styles.module.scss';

const withVisibleXs = (Component = Noop) => withStyles(Component, styles, 'visible-xs');
const withVisibleSm = (Component = Noop) => withStyles(Component, styles, 'visible-sm');
const withVisibleMd = (Component = Noop) => withStyles(Component, styles, 'visible-md');
const withVisibleLg = (Component = Noop) => withStyles(Component, styles, 'visible-lg');
const withVisibleXl = (Component = Noop) => withStyles(Component, styles, 'visible-xl');
const withVisibleXxl = (Component = Noop) => withStyles(Component, styles, 'visible-xxl');
const withVisibleDesktop = (Component = Noop) => withStyles(Component, styles, 'visible-desktop');
const withVisibleDesktop993 = (Component = Noop) =>
  withStyles(Component, styles, 'visible-desktop-993');
const withVisibleDesktop1100 = (Component = Noop) =>
  withStyles(Component, styles, 'visible-desktop-1100');

const withHiddenXs = (Component = Noop) => withStyles(Component, styles, 'hidden-xs');
const withHiddenSm = (Component = Noop) => withStyles(Component, styles, 'hidden-sm');
const withHiddenMd = (Component = Noop) => withStyles(Component, styles, 'hidden-md');
const withHiddenLg = (Component = Noop) => withStyles(Component, styles, 'hidden-lg');
const withHiddenXl = (Component = Noop) => withStyles(Component, styles, 'hidden-xl');
const withHiddenXxl = (Component = Noop) => withStyles(Component, styles, 'hidden-xxl');
const withHiddenDesktop = (Component = Noop) => withStyles(Component, styles, 'hidden-desktop');
const withHiddenDesktop993 = (Component = Noop) =>
  withStyles(Component, styles, 'hidden-desktop-993');
const withHiddenDesktop1100 = (Component = Noop) =>
  withStyles(Component, styles, 'hidden-desktop-1100');

export {
  withVisibleXs,
  withVisibleSm,
  withVisibleMd,
  withVisibleLg,
  withVisibleXl,
  withVisibleXxl,
  withVisibleDesktop,
  withVisibleDesktop993,
  withVisibleDesktop1100,
  withHiddenXs,
  withHiddenSm,
  withHiddenMd,
  withHiddenLg,
  withHiddenXl,
  withHiddenXxl,
  withHiddenDesktop,
  withHiddenDesktop993,
  withHiddenDesktop1100
};
